import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { TablePdf } from "../TablePdf/TablePdf";
import { TableHeader as TableHeaderPDF } from "@david.kucsai/react-pdf-table/lib/TableHeader";
import { TableCell as TableCellPDF } from "@david.kucsai/react-pdf-table/lib/TableCell";
import { TableBody as TableBodyPDF } from "@david.kucsai/react-pdf-table/lib/TableBody";
import { DataTableCell } from "@david.kucsai/react-pdf-table";
import GetCurrency from "../../helper/GetCurrency";

export default function ViewReceiptTypes(props) {
  let totalCount = 0;
  let totalAmount = 0;

  let data = Object.keys(props.receiptTypes).map((receiptType) => {
    totalCount += props.receiptTypes[receiptType].count;
    totalAmount += props.receiptTypes[receiptType].amount;
    return {
      receiptType: receiptType,
      count: props.receiptTypes[receiptType].count,
      amount: GetCurrency() + (props.receiptTypes[receiptType].amount / 100.0).toFixed(2),
    };
  });

  let receiptTypes = Object.keys(props.receiptTypes).map((receiptType) => {
    return (
      <TableRow key={receiptType}>
        <TableCell>{receiptType}</TableCell>
        <TableCell align={"right"}>{props.receiptTypes[receiptType].count}</TableCell>
        <TableCell align={"right"}>
          {GetCurrency()} {(props.receiptTypes[receiptType].amount / 100.0).toFixed(2)}
        </TableCell>
      </TableRow>
    );
  });

  const getPdfView = () => {
    return (
      <TablePdf data={data}>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Bestellingen</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            Aantal
          </TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            Bedrag
          </TableCellPDF>
        </TableHeaderPDF>
        <TableBodyPDF>
          <DataTableCell weighting={0.3} getContent={(r) => r.receiptType} />
          <DataTableCell weighting={0.3} align={"right"} getContent={(r) => r.count} />
          <DataTableCell weighting={0.3} align={"right"} getContent={(r) => r.amount} />
        </TableBodyPDF>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Totaal</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            {totalCount}
          </TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            {GetCurrency() + (totalAmount / 100.0).toFixed(2)}
          </TableCellPDF>
        </TableHeaderPDF>
      </TablePdf>
    );
  };

  props.createPdf(getPdfView());

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Bestellingen</TableCell>
            <TableCell align={"right"}>Aantal</TableCell>
            <TableCell align={"right"}>Bedrag</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{receiptTypes}</TableBody>
        <TableFooter>
          <TableRow>
            <TableCell>Totaal</TableCell>
            <TableCell align={"right"}>{totalCount}</TableCell>
            <TableCell align={"right"}>
              {GetCurrency()} {(totalAmount / 100.0).toFixed(2)}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
